import {gsap} from "gsap";
import {NineToFive} from "../NineToFive";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";
import {BasedCountUp} from "./BasedCountUp";

export class FreespinsOutroInformation extends PIXI.Container {
    private totalWinStyle:PIXI.TextStyle;
    private freespinsTotalWin:PIXI.Text;
    private basedCountUp:BasedCountUp;
    private spinsPlayedStyle:PIXI.TextStyle;
    private freespinsSpinsPlayed:PIXI.Text;
    private totalMultiplierStyle:PIXI.TextStyle;
    private freespinsTotalMultiplier:PIXI.Text;
    private freespinsActualMultiplier:PIXI.BitmapText;

    constructor() {
        super();
        // freespins outro
        this.totalWinStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: 1.5,
            dropShadowColor: "#000784",
            dropShadowDistance: 6,
            fill: "#ffffff",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#0000cc",
            strokeThickness: 8
        });
        this.freespinsTotalWin = new PIXI.Text(NineToFive.apiPlugin.translations.translate("YOU WON"), this.totalWinStyle);
        this.freespinsTotalWin.anchor.set(0.5,0.5);
        this.freespinsTotalWin.position.set(360,120);
        this.freespinsTotalWin.visible = false;

        this.basedCountUp = new BasedCountUp();
        this.basedCountUp.position.set(360,200);

        this.spinsPlayedStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#ffffff",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#232323",
            strokeThickness: 8
        });
        this.freespinsSpinsPlayed = new PIXI.Text(NineToFive.apiPlugin.translations.translate("Spins played: 69"), this.spinsPlayedStyle);
        this.freespinsSpinsPlayed.anchor.set(0.5,0.5);
        this.freespinsSpinsPlayed.position.set(360,360);
        this.freespinsSpinsPlayed.visible = false;

        this.totalMultiplierStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#fffc00",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8
        });
        this.freespinsTotalMultiplier = new PIXI.Text(NineToFive.apiPlugin.translations.translate("Final multiplier: "), this.totalMultiplierStyle);
        this.freespinsTotalMultiplier.anchor.set(0,0.5);
        this.freespinsTotalMultiplier.position.set(300,460);
        this.freespinsTotalMultiplier.visible = false;

        this.freespinsActualMultiplier = new PIXI.BitmapText("x1", {
            fontName : NineToFiveGameAssets.BITMAP_FONT_FS_MULTI,
            fontSize : 60,
        });
        this.freespinsActualMultiplier.position.set(480, 470);
        (<PIXI.Point>this.freespinsActualMultiplier.anchor).set(0, 0.5);
        this.freespinsActualMultiplier.visible = false;

        this.addChild(this.freespinsTotalWin);
        this.addChild(this.basedCountUp);
        this.addChild(this.freespinsSpinsPlayed);
        this.addChild(this.freespinsTotalMultiplier);
        this.addChild(this.freespinsActualMultiplier);
    }

    public showOutroInformation():gsap.core.Timeline {
        const fsMulti = NineToFive.model.gameData.fsMultiplier;
        const noMulti = NineToFive.model.gameData.accumulatedFSWin;
        const multi = NineToFive.model.gameData.accumulatedRoundWin;
        const winAboveBet = !NineToFive.isWinBelowStake();
        return gsap.timeline()
            .add(() =>  {
                this.freespinsTotalWin.visible = multi > 0 && winAboveBet;
                if (winAboveBet) {
                    NineToFive.soundPlayer.playSound("fsOutroPresentation");
                }
            })
            .add(this.basedCountUp.countUpInstant(winAboveBet ? (fsMulti > 1 ? noMulti : multi) : multi, 0), '>0.2')
            .add(() =>  {
                if (winAboveBet) {
                    NineToFive.soundPlayer.playSound("fsOutroPresentation");
                }
            }, '<')
            .add(() =>  {
                this.freespinsSpinsPlayed.scale.set(1,1);
                const spinPlayed: number = NineToFive.model.gameData.freeSpinsPlayed;
                this.freespinsSpinsPlayed.text = NineToFive.apiPlugin.translations.translate("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
                if (this.freespinsSpinsPlayed.width > 700) {
                    const newScale = 700 / this.freespinsSpinsPlayed.width;
                    this.freespinsSpinsPlayed.scale.set(newScale, newScale);
                }
                //Translation.translation("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
                this.freespinsSpinsPlayed.visible = true;
                if (winAboveBet) {
                    NineToFive.soundPlayer.playSound("fsOutroPresentation");
                }
            }, '>0.2')
            .add(() =>  {
                this.freespinsTotalMultiplier.visible = true;

                // (ugly) fix to make sure text scales and doesnt go outside screen
                this.freespinsActualMultiplier.scale.set(1,1);
                this.freespinsTotalMultiplier.scale.set(1,1);

                this.freespinsActualMultiplier.text = `x${fsMulti}`;

                // magic number 20 being the small overlap between them
                const totalMultiplierWidth = this.freespinsActualMultiplier.width + this.freespinsTotalMultiplier.width - 20;
                if (totalMultiplierWidth > 700) {
                    const newScale = 700 / totalMultiplierWidth;
                    this.freespinsActualMultiplier.scale.set(newScale, newScale);
                    this.freespinsTotalMultiplier.scale.set(newScale, newScale);
                }
                const totalMultiplierWidthAdjusted = this.freespinsActualMultiplier.width + this.freespinsTotalMultiplier.width - 20;

                const textStartingPosition = (720 - totalMultiplierWidthAdjusted) / 2;
                this.freespinsTotalMultiplier.position.set(textStartingPosition, 460);
                this.freespinsActualMultiplier.position.set(textStartingPosition + this.freespinsTotalMultiplier.width - 20, 470)

                if (winAboveBet) {
                    NineToFive.soundPlayer.playSound("fsOutroPresentation");
                }
            }, '>0.2')
            .add(() =>  {
                this.freespinsActualMultiplier.visible = true;
                if (winAboveBet) {
                    NineToFive.soundPlayer.playSound("fsOutroPresentation");
                }
            }, '>0.2')
            // maybe rethink this, if statements arent that bad :woozy:
            .add(fsMulti > 1 && multi > 0 && winAboveBet
                ? () => { NineToFive.soundPlayer.playSound("fsOutroCountUp"); }
                : () => {}, multi > 1 ? '>0.5' : '>' )
            .add(fsMulti > 1 && multi > 0 && winAboveBet
                ? this.basedCountUp.countUpNoFade(multi, noMulti, 1.5)
                : () => {}, '<')
            .add(fsMulti > 1 && multi > 0 && winAboveBet
                ? () => {
                    NineToFive.soundPlayer.playSound("fsOutroCountUpEnd");
                    NineToFive.soundPlayer.stopSound("fsOutroCountUp");
                }
                : () => {})
    }

    public hideOutroInformation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.freespinsTotalWin.visible = false;
                this.basedCountUp.hide();
                this.freespinsSpinsPlayed.visible = false;
                this.freespinsTotalMultiplier.visible = false;
                this.freespinsActualMultiplier.visible = false;
            });
    }
}